<template>
  <div id="customizer-container" data-product="81067"
       data-product-url="#"
       data-product-type="variable"
       data-product-view="single">
  <div id="app">
    <Customizer/>
  </div>
  </div>
</template>

<script>
import Customizer from "@/components/Customizer";

export default {
  name: 'App',
  components: {
    Customizer
  }
}
</script>

<style>
</style>
